import api from "./api";
import bootstrapVue from "./bootstrapVue";
import leaflet from "./leaflet";
import meta from "./meta";

export default [api, bootstrapVue, leaflet, meta];
